export default __webpack_public_path__ + "static/solutions-link-icon5.url-eb2bacd788d69b8a656da18103d9ef98.svg";